import { merge, reduce } from 'lodash';

import { increment, decrement, updatedCounters } from '../services/counters';
import { ADD_USER } from '../actions/add-user';
import { SET_CURRENT_USER } from '../actions/set-current-user';
import { FETCH_USER_SUCCESS } from '../actions/fetch-user';
import { FETCH_MEMBERS_SUCCESS } from '../actions/fetch-members';
import { CREATE_USER_SUCCESS } from '../actions/create-user';
import { UPDATE_USER_SUCCESS } from '../actions/update-user';
import { BLOCK_USER_SUCCESS } from '../actions/block-user';
import { UNBLOCK_USER_SUCCESS } from '../actions/unblock-user';
import { SUBSCRIBE_FAILURE, SUBSCRIBE_REQUEST } from '../actions/subscribe';
import { UNSUBSCRIBE_FAILURE, UNSUBSCRIBE_REQUEST } from '../actions/unsubscribe';
import { PROMOTE_MODERATOR_SUCCESS } from '../actions/promote-moderator';
import { DEMOTE_MODERATOR_SUCCESS } from '../actions/demote-moderator';
import { USER_SET_PERMISSIONS } from '../actions/user-socket';
import { FETCH_FOLLOWERS_SUCCESS } from '../actions/fetch-followers';
import { FETCH_FOLLOWING_SUCCESS } from '../actions/fetch-following';

const addUsers = (state, users) =>
  reduce(
    users,
    (acc, user) => ({
      ...acc,
      [user._id]: {
        ...acc[user._id],
        ...user,
      },
    }),
    { ...state }
  );

const updateSubscription = ({ state, payload, isSubscribed }) => {
  const userId = payload.type === 'user' && payload._id;
  const user = state[userId];
  if (!user) {
    return state;
  }

  return merge({}, state, {
    [userId]: {
      ...updatedCounters(user, 'followerCount', isSubscribed ? increment : decrement),
      isSubscribed,
    },
  });
};

// eslint-disable-next-line complexity
export default (state = {}, action = {}) => {
  switch (action.type) {
    case ADD_USER:
    case SET_CURRENT_USER:
    case FETCH_USER_SUCCESS:
    case CREATE_USER_SUCCESS:
    case UPDATE_USER_SUCCESS:
    case BLOCK_USER_SUCCESS:
    case UNBLOCK_USER_SUCCESS:
    case PROMOTE_MODERATOR_SUCCESS:
    case DEMOTE_MODERATOR_SUCCESS:
    case USER_SET_PERMISSIONS:
      return addUsers(state, [action.payload]);
    case FETCH_MEMBERS_SUCCESS:
      return addUsers(state, action.payload);
    case SUBSCRIBE_REQUEST:
      return updateSubscription({ state, payload: action.payload, isSubscribed: true });
    case SUBSCRIBE_FAILURE:
      return updateSubscription({ state, payload: action.payload, isSubscribed: false });
    case UNSUBSCRIBE_REQUEST:
      return updateSubscription({ state, payload: action.payload, isSubscribed: false });
    case UNSUBSCRIBE_FAILURE:
      return updateSubscription({ state, payload: action.payload, isSubscribed: true });
    case FETCH_FOLLOWERS_SUCCESS:
      return addUsers(state, action.payload.followers);
    case FETCH_FOLLOWING_SUCCESS:
      return addUsers(state, action.payload.following);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/users.js